import { assetPrefix } from '../../constants/app';
import { ChartbitProps } from './types';

const handleBackgroundColor = (
  isDark: boolean,
  isDesktop: ChartbitProps['isDesktop'],
) => {
  if (isDesktop || isDark) {
    return '#1F1F1F';
  }

  return '#fff';
};

const handleCustomCss = (
  isMobile: ChartbitProps['isMobile'],
  isDesktop: ChartbitProps['isDesktop'],
) => {
  if (isDesktop) return '../../tradingview/styles/custom-desktop.css';
  if (isMobile) return `${assetPrefix}/tradingview/styles/custom-mobile.css`;
  return `${assetPrefix}/tradingview/styles/custom.css`;
};

export const getValueForLowestKey = <T extends Record<number | string, any>>(
  object: T,
  index: number,
) => {
  let returned: T[keyof T];

  for (const key in object) {
    if (Number(key) > index) break;
    returned = object[key];
  }

  return returned;
};

export { handleBackgroundColor, handleCustomCss };
